@if (IpData) {
  <div>
    <h3 class="mb-3">{{name}}'s independent prescriber application</h3>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="name">Name</label>
            <div class="form-control readonly" [innerHTML]="name">
            </div>
          </div>
        </div>
        @if (IpData.countersignatures[0]?.isMentorRegistered === true) {
          <div class="col-md-4">
            <div class="form-group">
              <label for="registrationNumber">Mentor registration number</label>
              <div style="min-height: 40px;" class="form-control readonly"
                [innerHTML]="IpData.countersignatures[0]?.registrationNumber">
              </div>
            </div>
          </div>
        }
        <div class="col-md-4">
          <div class="form-group">
            <label for="submittedAt">Submitted at</label>
            <div style="min-height: 40px;" class="form-control readonly"
              [innerHTML]="IpData.dateApplicationSubmitted | utcDate">
            </div>
          </div>
        </div>
        <app-collapsible [trigger]="!dateLessthanSixMonths">
          @if (IpData.countersignatures[0]?.isMentorRegistered === true ) {
            <div class="col-md-4">
              <div class="form-group">
                <label for="grade">Outcome</label>
                <div class="form-control readonly"
                  [innerHTML]="IpData.countersignatures[0]?.decision === 999 ? 'Unsatisfactory': 'Satisfactory'">
                </div>
              </div>
            </div>
          }
        </app-collapsible>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12 mb-2">
          <h4>Qualification Details</h4>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="courseProvider">Course title</label>
            <div class="form-control readonly" [innerHTML]="application.courseDetails?.userQualificationDetails.courseName"></div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="dateAwarded">Date awarded</label>
            <div class="form-control readonly" [innerHTML]="application.courseDetails?.dateObtained | utcDate"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="clinicalSpecialities">Clinical specialties in which you will have prescribing responsibilities</label>
            <div class="form-control readonly"
            [innerHTML]="IpData.clinicalSpecialities "></div>
          </div>
        </div>
      </div>
    </div>
    <app-collapsible [trigger]='!dateLessthanSixMonths && IpData.countersignatures[0]'>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="prescriberMentor">Is your prescriber mentor registered with the GPhC?</label>
              <div class="form-control readonly"
              [innerHTML]="IpData.countersignatures[0]?.isMentorRegistered === true ? 'Yes': 'No'"></div>
            </div>
          </div>
        </div>
      </div>
      @if (IpData.countersignatures[0]?.isMentorRegistered === false) {
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="mentorName">Prescriber mentor name</label>
                <div class="form-control readonly" [innerHTML]="IpData.countersignatures[0]?.prescriberMentorName"></div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="registrationNumber">Registration number</label>
                <div class="form-control readonly" [innerHTML]="IpData.countersignatures[0]?.prescriberRegistrationNo"></div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="regulatoryBody">UK regulatory body </label>
                <div class="form-control readonly"
                [innerHTML]="IpData.countersignatures[0]?.ukRegulatoryBody "></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>I have provided a copy of a letter from this prescriber,
                confirming that they are willing to act as a mentor</label>
                <div style="min-height: 40px;" class="form-control readonly">
                  @for (proof of IpData.attachments; track proof) {
                    <div>
                      <div class="flexi">
                        <button class="download-button" [disabled]="downloading" [class.disabled]="downloading">
                          <a (click)="download(proof)" [class.disabled]="downloading">
                            <div class="filename"> <i [class]="getIcon(proof)" style="white-space: nowrap;"></i> {{proof.filename}}
                            <i class="fa fa-download" style="white-space: nowrap;"></i></div>
                          </a>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      @if (IpData.countersignatures[0]?.isMentorRegistered === true) {
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="mentorName">Prescriber mentor name</label>
                <div class="form-control readonly" [innerHTML]="IpData.countersignatures[0]?.forenames + '' + IpData.countersignatures[0]?.surname"></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="registrationNumber">Registration number</label>
                <div class="form-control readonly" [innerHTML]="IpData.countersignatures[0]?.registrationNumber"></div>
              </div>
            </div>
          </div>
        </div>
      }
    </app-collapsible>
    @if (IpData.countersignatures[0]) {
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 mb-2">
            <h4>Declarations</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group">
            <label for="qualifiedIndependentPrescriber"> I am qualified to practise as an independent prescriber</label>
            <div class="form-control readonly" [innerHTML]="IpData.declaration?.isQ1Confirmed === true ? 'Yes':'No'">
            </div>
          </div>
          <div class="col-md-12 form-group">
            <label for="part1EntryAnnotation">I request my entry in Part 1 of the register to be annotated as an independent prescriber</label>
            <div class="form-control readonly" [innerHTML]="IpData.declaration?.isQ2Confirmed === true ? 'Yes':'No'">
            </div>
          </div>
          <div class="col-md-12 form-group">
            <label for="confirmNotificationFromGphc">I understand that I must not prescribe until I receive the confirmation notification within myGPhC</label>
            <div class="form-control readonly" [innerHTML]="IpData.declaration?.isQ3Confirmed === true ? 'Yes':'No'">
            </div>
          </div>
          <div class="col-md-12 form-group">
            <label for="confirmingInformationIsAccurate">The information that I have provided in this application, and within any supporting documentation that I have uploaded, is complete, true and accurate</label>
            <div class="form-control readonly" [innerHTML]="IpData.declaration?.isQ4Confirmed === true ? 'Yes':'No'">
            </div>
          </div>
          <div class="col-md-12 form-group">
            <label for="confirmingNotGivenMisleadingInfo">I understand that if I am found to have given false or misleading information in connection with my application, this may be treated as misconduct, and could result in my removal from the register</label>
            <div class="form-control readonly" [innerHTML]="IpData.declaration?.isQ5Confirmed === true ? 'Yes':'No'">
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}